var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"value":_vm.is_active,"labels":true,"sync":true},on:{"change":function($event){return _vm.toggleHeatmap()}}})}
var staticRenderFns = []

export { render, staticRenderFns }